/*
  MAIN & TAYLOR — keep the recorded return eligibility in step with the selected
  variant. (Until 16 Sep 2026 this also toggled a return-policy notice under Add to
  Cart; that notice was removed at the client's request, so the hidden order
  properties are the only thing this file maintains.)

  The final-sale rule itself lives in Liquid (compare_at_price > price) and is
  emitted per option as data-mt-final-sale. This file only transports that value;
  it deliberately does not recompute the rule, because a second copy of it in JS
  is how the two halves drift apart.
*/
(function () {
  'use strict';

  function syncForm(form) {
    if (!form) return;

    var select = form.querySelector('[data-product-select]');
    var compareAt = form.querySelector('[data-mt-compare-at-snapshot]');
    var eligibility = form.querySelector('[data-mt-return-eligibility]');
    if (!select || !compareAt || !eligibility) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var isFinal = option.getAttribute('data-mt-final-sale') === 'true';
    compareAt.value = String(Number(option.getAttribute('data-mt-compare-at') || 0));
    eligibility.value = isFinal ? 'final_sale' : 'eligible_non_sale';
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-product-select]')) return;
    syncForm(event.target.closest('form'));
  });

  // Capture phase: the eligibility value has to be correct in the payload that is
  // already being submitted, not after the default handler has read the form.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    syncForm(form);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(syncForm);
  });
})();
